
import comm_data from './../comm_data';
// import './dataHandler_dateFormat';
import api from './api';

// // ⌬ 1.1 React-i18next
// import { useTranslation } from "react-i18next";
// // ⌬ 1.2 React-i18next
// const { t, i18n } = useTranslation();

export default class ApiGo_AuditTrail {
    // ※static 靜態屬性不需要實例化也可以調用，可以減少內存的配置
    // Ω Audit Trail 共用 - API
    /**
     * ✏*: GET - 登入者資料
     *     
     * @param {String} _id 登入者id
     */
    static getUser() {
        // key不存在，預設讀到的值為null
        if (localStorage.getItem('currentAccount') !== null || localStorage.getItem('currentAccount') !== undefined) {
            const currentAccount = localStorage.getItem('currentAccount'); // 取得目前登入帳號
            const user = JSON.parse(localStorage.getItem(currentAccount)); // 取得目前登入帳號 使用者資料
            return user;
        }

    }

    /**
     * // NOTE: GET -查詢所有使用者操作紀錄
     */
    static getAuditTrailGet() {
        /**
         * @param {String} _id 登入者id
         */
        // http://192.168.0.50/audit_trail_get_single?id=19
        const apiParas = {
            type: 'audit_trail_get',
        };

        return api({
            url: `${comm_data.API_HOST}/${apiParas.type}`,
            type: apiParas.type,
        })
    }

    /**
     * // NOTE: GET - 查詢指定使用者操作紀錄
     */
    static getAuditTrailGetSingle() {
        /**
         * @param {String} _id 登入者id
         */
        // http://192.168.0.50/audit_trail_get_single?id=19
        const apiParas = {
            type: 'audit_trail_get_single',

            // 參數寫在這裡面 // mac=B827EB80B170
            searchParams: new URLSearchParams({
                // id: String(_id) || '19',
                id: String(ApiGo_AuditTrail.getUser().id), // 捉取登入者id
            })
        };

        let Url = new URL(`${comm_data.API_HOST}/${apiParas.type}`);
        Url.search = apiParas.searchParams; // ?id=19
        return api({
            // url: Url
            url: Url.href,
            type: apiParas.type,
            // method: "GET" // 測試用
        })
    }

    /**
     * ✏*: POST - Audit Trail 使用者操作紀錄 (僅記錄 put、post、delete)
     * 
     * @param {string} _action 記錄的發生事件
     * @param {string} _i18n_type 給i18n文本的判斷key值 (輸入api function名稱即可)
     */
    // static postAuditTrail(_institution, _user_id, _action) {
    static postAuditTrail(_action, _i18n_type, audit_trail_data) {
        /**
         * X param {string} _institution 機構名稱
         * X param {number} _user_id 登入者
         * X param {string} _action 發生事件
         */
        const apiParas = {
            type: 'audit_trail_post',
        };
        // 當特殊情況，需要紀錄除了 action 以外的資訊時：

        const data = {
            // institution: _institution || "TEST Inst",
            institution: String((ApiGo_AuditTrail.getUser()!==null)?ApiGo_AuditTrail.getUser().institution: "TEST Inst"),
            user_id: Number((ApiGo_AuditTrail.getUser()!==null)?ApiGo_AuditTrail.getUser().id:"logout"),
            action: String(_action),
            i18n_type: String(_i18n_type),
        } 

        fetch(`${comm_data.API_HOST}/${apiParas.type}`, { // url 請求位置
            method: 'POST', //請求方法
            // 發送給伺服器的資料
            body: data ? JSON.stringify(data) : null,
            // body: data || null,
            headers: {
                'content-type': 'application/json'
            },
        }).then(res => {
            if (
                // (res.status === 200 || res.status === 201) &&
                (data.action !== null || data.action !== undefined) &&
                (data.i18n_type !== null || data.i18n_type !== undefined)
            ) {
                return res.json(); // 輸出成 json
            }
            
        }).catch(err => console.error('Error:', err))
    }

}